// LPC — Compte à rebours promo multilingue, à DATE FIXE (remplace apple-promo-rolling.js).
// Règle interne LPC (avril 2026) : aucune fenêtre glissante, aucun « ce soir à minuit »
// recalculé chaque jour. La date de fin vient d'un réglage global du thème
// (Réglages du thème → Promotion → promo_end_at, heure de Paris) et les textes
// viennent des fichiers de locales (lpc_i18n.promo_countdown.*), injectés en
// data-attributes par le snippet lpc-promo-countdown.liquid.
//
// Conteneur : [data-lpc-countdown] avec data-end="AAAA-MM-JJTHH:MM" (heure de Paris),
//   data-start (optionnel), data-lang (code langue de la page), data-hide-when-ended,
//   data-i18n-ends-in, data-i18n-last-day, data-i18n-remaining-dhm, data-i18n-remaining-hm,
//   data-i18n-until, data-i18n-from-to, data-i18n-ended.
// Enfants optionnels : [data-lpc-cd-label], [data-lpc-cd-value], [data-lpc-cd-until],
//   [data-lpc-cd-range], [data-lpc-cd-start-day], [data-lpc-cd-start-month],
//   [data-lpc-cd-end-day], [data-lpc-cd-end-month].
(function () {
  'use strict';

  var TIME_ZONE = 'Europe/Paris';
  var partsFormatter = null;
  try {
    partsFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
  } catch (e) { partsFormatter = null; }

  function parisParts(date) {
    if (!partsFormatter || !partsFormatter.formatToParts) {
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate(),
        hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds() };
    }
    var v = {};
    partsFormatter.formatToParts(date).forEach(function (p) { if (p.type !== 'literal') v[p.type] = Number(p.value); });
    return { year: v.year, month: v.month, day: v.day, hour: v.hour, minute: v.minute, second: v.second };
  }

  function zoneOffsetMs(date) {
    var p = parisParts(date);
    var utcLike = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return utcLike - Math.floor(date.getTime() / 1000) * 1000;
  }

  // "2026-10-31T23:59" (heure de Paris) -> instant UTC
  function parseParisWallTime(str) {
    if (!str) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(String(str).trim());
    if (!m) return null;
    var y = +m[1], mo = +m[2], d = +m[3];
    var h = m[4] != null ? +m[4] : 23, mi = m[5] != null ? +m[5] : 59, s = m[6] != null ? +m[6] : 59;
    var utcLike = Date.UTC(y, mo - 1, d, h, mi, s);
    var first = zoneOffsetMs(new Date(utcLike));
    var result = new Date(utcLike - first);
    var second = zoneOffsetMs(result);
    if (second !== first) result = new Date(utcLike - second);
    return result;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function fill(template, vars) {
    var out = template || '';
    Object.keys(vars).forEach(function (k) { out = out.split('[' + k + ']').join(String(vars[k])); });
    return out;
  }

  function fmt(date, lang, opts) {
    try {
      opts.timeZone = TIME_ZONE;
      return new Intl.DateTimeFormat(lang || 'fr', opts).format(date);
    } catch (e) {
      return date.getDate() + '/' + (date.getMonth() + 1);
    }
  }

  function getState(endStr, startStr, now) {
    now = now || new Date();
    var end = parseParisWallTime(endStr);
    if (!end) return null;
    var start = parseParisWallTime(startStr);
    var diff = end.getTime() - now.getTime();
    var ended = diff <= 0;
    var d = Math.max(0, diff);
    var days = Math.floor(d / 86400000);
    var hours = Math.floor((d % 86400000) / 3600000);
    var minutes = Math.floor((d % 3600000) / 60000);
    var seconds = Math.floor((d % 60000) / 1000);
    return {
      end: end, start: start, ended: ended, diffMs: diff,
      days: days, hours: hours, minutes: minutes, seconds: seconds,
      lastDay: !ended && diff < 86400000,
      clock: pad(days * 24 + hours) + ':' + pad(minutes) + ':' + pad(seconds)
    };
  }

  function render(el) {
    var st = getState(el.getAttribute('data-end'), el.getAttribute('data-start'));
    var lang = el.getAttribute('data-lang') || document.documentElement.lang || 'fr';
    var block = el.hasAttribute('data-lpc-promo-block') ? el : (el.closest ? el.closest('[data-lpc-promo-block]') : null);
    if (!st) { el.hidden = true; return; }
    var label = el.querySelector('[data-lpc-cd-label]');
    var value = el.querySelector('[data-lpc-cd-value]');
    var until = el.querySelector('[data-lpc-cd-until]');
    var range = el.querySelector('[data-lpc-cd-range]');
    var sDay = el.querySelector('[data-lpc-cd-start-day]');
    var sMon = el.querySelector('[data-lpc-cd-start-month]');
    var eDay = el.querySelector('[data-lpc-cd-end-day]');
    var eMon = el.querySelector('[data-lpc-cd-end-month]');
    var i18n = function (k) { return el.getAttribute('data-i18n-' + k) || ''; };

    if (st.ended) {
      el.classList.add('is-ended');
      el.setAttribute('data-ended', 'true');
      if (label) label.textContent = i18n('ended');
      if (value) value.textContent = '';
      if (until) until.textContent = '';
      if (el.hasAttribute('data-hide-when-ended') && block) block.hidden = true;
      return;
    }

    if (until) until.textContent = fill(i18n('until'), { date: fmt(st.end, lang, { day: 'numeric', month: 'long' }) });
    if (range) {
      range.textContent = st.start
        ? fill(i18n('from-to'), { start: fmt(st.start, lang, { day: 'numeric', month: 'long' }), end: fmt(st.end, lang, { day: 'numeric', month: 'long' }) })
        : fill(i18n('until'), { date: fmt(st.end, lang, { day: 'numeric', month: 'long' }) });
    }
    if (st.start) {
      if (sDay) sDay.textContent = fmt(st.start, lang, { day: 'numeric' });
      if (sMon) sMon.textContent = fmt(st.start, lang, { month: 'short' });
    }
    if (eDay) eDay.textContent = fmt(st.end, lang, { day: 'numeric' });
    if (eMon) eMon.textContent = fmt(st.end, lang, { month: 'short' });

    el.classList.toggle('is-last-day', st.lastDay);
    if (label) label.textContent = st.lastDay ? i18n('last-day') : i18n('ends-in');
    if (value) {
      value.textContent = st.lastDay
        ? fill(i18n('remaining-hm'), { hours: st.hours, minutes: pad(st.minutes) })
        : fill(i18n('remaining-dhm'), { days: st.days, hours: st.hours, minutes: pad(st.minutes) });
    }
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-lpc-countdown]');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }

  window.LPCPromoCountdown = { getState: getState, parseParisWallTime: parseParisWallTime, render: tick, timeZone: TIME_ZONE };

  function boot() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
